(ns accounts.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::script-loaded? boolean?)
(s/def ::token (s/nilable string?))
(s/def ::unavailable? boolean?)
(s/def ::quovo (s/keys ::opt-un [::script-loaded?
                                 ::token
                                 ::unavailable?]))


(s/def ::id (s/and string? #(not (empty? %))))
(s/def ::institution-name string?)
(s/def ::status (s/nilable string?))
(s/def ::status-description (s/nilable string?))
(s/def ::quovo-connection (s/or :manual-account nil?
                                :quovo-account (s/keys :req-un [::id
                                                                ::institution-name
                                                                ::status
                                                                ::status-description])))
(s/def ::quovo-connection-id (s/or :manual-account nil?
                                   :quovo-account string?))
(s/def ::quovo-connections (s/or :connections (s/coll-of ::quovo-connection)
                                 :none nil?
                                 :error #{:error}))

(s/def :internal/id string?)
(s/def :external/id string?)
(s/def ::account-number (s/nilable string?))
(s/def ::custodian string?)
(s/def ::market-value float?)
(s/def ::name (s/and string? #(not (empty? %))))
(s/def ::percent (s/and float? #(<= % 100)))
(s/def ::strategy string?)
;; @TODO this is not complete enough
(s/def ::type (s/and string? #(not (empty? %))))
(s/def ::sub-type (s/nilable (s/and string? #(not (empty? %)))))
(s/def :internal/account (s/keys :req-un [::account-number
                                          ::custodian
                                          :internal/id
                                          ::market-value
                                          ::name
                                          ::percent
                                          ::strategy
                                          ::type]))

(s/def :external/account (s/keys :req-un [::account-number
                                          ::custodian
                                          :external/id
                                          ::market-value
                                          ::name
                                          ::type
                                          ::quovo-connection-id]
                                 :opt-un [::sub-type]))
(s/def ::total-value float?)
(s/def :internal/accounts (s/map-of :internal/id :internal/account))
(s/def :external/accounts (s/map-of :external/id :external/account))
(s/def ::external (s/keys :req-un [::total-value
                                   :external/accounts]))
(s/def ::internal (s/keys :req-un [::total-value
                                   :internal/accounts]))
(s/def ::color (s/and string? #(not (empty? %1))))
(s/def ::focused (s/keys :req-un [::color
                                  :internal/id]))

(s/def ::error boolean?)
(s/def ::message (s/nilable string?))
(s/def ::submitting? boolean?)
(s/def ::form (s/keys :opt-un [::error
                               ::submitting?
                               ::message]))

(s/def ::accounts (s/keys :req-un [::internal
                                   ::external]
                          :opt-un [::focused
                                   ::form]))
